var messages$1 = {
	"button.cancel": [
		"Cancel"
	],
	"button.continue": [
		"Continue"
	],
	"button.createPasskey": [
		"Create a Passkey"
	],
	"button.createPasswordInstead": [
		"Create a password instead"
	],
	"button.delete": [
		"Delete"
	],
	"button.done": [
		"Done"
	],
	"button.edit": [
		"Edit"
	],
	"button.emailLogin": [
		"Continue with email"
	],
	"button.emailMagicLink": [
		"Email me a login link"
	],
	"button.emailOTP": [
		"Email me a login code"
	],
	"button.emailResent": [
		"Email resent! Try again in ",
		[
			"timeRemaining"
		],
		"s"
	],
	"button.forgotPassword": [
		"Forgot your password?"
	],
	"button.goBack": [
		"Go back"
	],
	"button.hidePassword": [
		"Hide"
	],
	"button.loginWithPasskey": [
		"Login with a Passkey"
	],
	"button.loginWithoutPassword": [
		"Log in without a password"
	],
	"button.resendEmail": [
		"Resend email"
	],
	"button.save": [
		"Save"
	],
	"button.showPassword": [
		"Show"
	],
	"button.skip": [
		"Skip"
	],
	"button.sms": [
		"Continue with text message"
	],
	"button.whatsapp": [
		"Continue with WhatsApp"
	],
	"createAccount.title": [
		"Choose how you would like to create your account."
	],
	"crypto.connectWallet.instructionPopup": [
		"Complete sign in by connecting through the wallet pop up in the right corner of your screen."
	],
	"crypto.connectWallet.title": [
		"Connecting to your wallet..."
	],
	"crypto.continueWithOtherWallet.title": [
		"Continue with other wallet"
	],
	"crypto.error.content": [
		"Your sign in request could not be completed. Go back to the main screen and try logging in again."
	],
	"crypto.error.title": [
		"Looks like there was an error"
	],
	"crypto.setupNewWallet.content": [
		"Get started by downloading any Ethereum or Solana wallet."
	],
	"crypto.setupNewWallet.instruction": [
		"We’ve included a few examples of wallet extensions you can find below. Once you’ve set up your wallet, click “Go back” to use it and sign in."
	],
	"crypto.setupNewWallet.title": [
		"Set up a new crypto wallet"
	],
	"crypto.signMessage.instruction": [
		"Complete the signature request through the wallet pop up in the right corner of your screen."
	],
	"crypto.signMessage.title": [
		"Completing signature request..."
	],
	"crypto.success.content": [
		"You have successfully connected your wallet."
	],
	"crypto.success.title": [
		"Success!"
	],
	"crypto.troubleHelp": [
		"If you are having trouble, go back to the main screen and try logging in again."
	],
	"crypto.wallet.binance": [
		"Binance"
	],
	"crypto.wallet.coinbase": [
		"Coinbase"
	],
	"crypto.wallet.continueWithBinance": [
		"Continue with Binance"
	],
	"crypto.wallet.continueWithCoinbase": [
		"Continue with Coinbase"
	],
	"crypto.wallet.continueWithEthereum": [
		"Continue with Other Ethereum Wallet"
	],
	"crypto.wallet.continueWithMetamask": [
		"Continue with Metamask"
	],
	"crypto.wallet.continueWithOtherWallet": [
		"Continue with other Crypto Wallet"
	],
	"crypto.wallet.continueWithPhantom": [
		"Continue with Phantom"
	],
	"crypto.wallet.continueWithSolana": [
		"Continue with Other Solana Wallet"
	],
	"crypto.wallet.metamask": [
		"Metamask"
	],
	"crypto.wallet.otherEthereum": [
		"Other Ethereum Wallet"
	],
	"crypto.wallet.otherSolana": [
		"Other Solana Wallet"
	],
	"crypto.wallet.phantom": [
		"Phantom"
	],
	"crypto.wallet.setupNewWallet": [
		"Set up a new crypto wallet"
	],
	"emailConfirmation.content": [
		"An email was sent to <bold>",
		[
			"email"
		],
		"</bold>."
	],
	"emailConfirmation.emailSent": [
		"Email sent! Try again in ",
		[
			"timeRemaining"
		],
		"s"
	],
	"emailConfirmation.title": [
		"Check your email"
	],
	"error.breachedPassword": [
		"Password appears in the list of breached passwords and must be reset."
	],
	"error.duplicatePasskey": [
		"The Passkey cannot be created as it seems to be already registered. It is possible this Passkey was registered on another device but has synced cross-device."
	],
	"error.duplicatePhoneNumber": [
		"A member with the specified phone number already exists for this organization."
	],
	"error.emailNotFound": [
		"Email not found."
	],
	"error.inactiveEmail": [
		"The email address is marked as inactive. Please try another email address, or contact your admin if you think this is a mistake."
	],
	"error.invalidCode": [
		"Code format is invalid, please try again."
	],
	"error.invalidEmail": [
		"Email format is invalid."
	],
	"error.invalidPhoneNumber": [
		"Phone number format is invalid. Ensure the phone number is in the E.164 format."
	],
	"error.invalidPhoneNumberCountryCode": [
		"The phone number's country code is invalid, unsupported, or disabled."
	],
	"error.invalidSessionToken": [
		"Invalid session token."
	],
	"error.memberPasswordNotFound": [
		"Member password not found."
	],
	"error.noUserPassword": [
		"Password not found for this user. Please try again."
	],
	"error.oauthFlowCallbackError": [
		"An error was encountered in the callback of the OAuth flow. Please try again."
	],
	"error.oauthTokenNotFound": [
		"OAuth Token could not be found."
	],
	"error.otpCodeNotFound": [
		"Invalid passcode, please try again."
	],
	"error.passkeyNotCreated": [
		"Your Passkey was not created. Click “Create a Passkey” to try again or skip without adding a Passkey."
	],
	"error.passkeyRegistrationNotFound": [
		"Passkey registration not found. You may have deleted the passkey from your account but not password manager. Please try again."
	],
	"error.passkeyUnknown": [
		"Unknown error occurred during passkey authentication. Please try again."
	],
	"error.resetPassword": [
		"Password must be reset."
	],
	"error.sessionNotFound": [
		"Session not found."
	],
	"error.title": [
		"Looks like there was an error!"
	],
	"error.unableToAuthMagicLink": [
		"The magic link could not be authenticated because it was either already used or expired. Please try again."
	],
	"error.unauthorizedAction": [
		"Unauthorized action."
	],
	"error.unauthorizedCredentials": [
		"Unauthorized credentials."
	],
	"error.unsubscribedPhoneNumber": [
		"Phone number is unsubscribed. User has unsubscribed. Resubscribe by texting 'START' before messages can be sent."
	],
	"error.userLockLimitReached": [
		"Too many failed authentication attempts. Please try again later."
	],
	"error.userUnauthenticated": [
		"Must have an active session to call this method. Have you logged in yet?"
	],
	"errors.invalidEmail": [
		"Invalid email address."
	],
	"formField.countryCode.label": [
		"Country code"
	],
	"formField.email.label": [
		"Email"
	],
	"formField.email.placeholder": [
		"example@email.com"
	],
	"formField.otp.ariaLabel": [
		"One-time passcode"
	],
	"formField.passcode.status.verifying": [
		"Verifying passcode..."
	],
	"formField.password.label": [
		"Password"
	],
	"formField.phone.label": [
		"Phone number"
	],
	"idpConsent.allowClientTo": [
		"Allow ",
		[
			"clientName"
		],
		" to:"
	],
	"idpConsent.button.allow": [
		"Allow"
	],
	"idpConsent.button.deny": [
		"Deny"
	],
	"idpConsent.customScopes.title": [
		[
			"clientName"
		],
		" wants to access your ",
		[
			"projectName"
		],
		" account"
	],
	"idpConsent.defaultClientName": [
		"The App"
	],
	"idpConsent.denied": [
		"Access to the application was denied."
	],
	"idpConsent.noActiveSession": [
		"No active session detected. Please log in to continue."
	],
	"idpConsent.noPermissionsToGrant": [
		"You do not have permissions to grant ",
		[
			"clientName"
		],
		" access to some of the requested scopes."
	],
	"idpConsent.signIn.title": [
		"Sign in to ",
		[
			"clientName"
		],
		" with ",
		[
			"projectName"
		]
	],
	"idpLogout.confirmMessage": [
		"Are you sure you want to log out of your ",
		[
			"projectName"
		],
		" account?"
	],
	"idpLogout.no": [
		"No"
	],
	"idpLogout.notLoggedOut": [
		"You have not been logged out. You may close this page."
	],
	"idpLogout.title": [
		"Log out?"
	],
	"idpLogout.yes": [
		"Yes"
	],
	"link.openInGmail": [
		"Open in Gmail"
	],
	"link.openInOutlook": [
		"Open in Outlook"
	],
	"link.openInYahoo": [
		"Open in Yahoo"
	],
	"loading.label": [
		"Loading"
	],
	"login.loading": [
		"Logging in..."
	],
	"login.success.content": [
		"You have successfully logged in."
	],
	"login.title": [
		"Sign up or log in"
	],
	"methodDivider.text": [
		"or"
	],
	"oauth.continueWithAmazon": [
		"Continue with Amazon"
	],
	"oauth.continueWithApple": [
		"Continue with Apple"
	],
	"oauth.continueWithBitbucket": [
		"Continue with Bitbucket"
	],
	"oauth.continueWithCoinbase": [
		"Continue with Coinbase"
	],
	"oauth.continueWithDiscord": [
		"Continue with Discord"
	],
	"oauth.continueWithFacebook": [
		"Continue with Facebook"
	],
	"oauth.continueWithFigma": [
		"Continue with Figma"
	],
	"oauth.continueWithGitHub": [
		"Continue with GitHub"
	],
	"oauth.continueWithGitLab": [
		"Continue with GitLab"
	],
	"oauth.continueWithGoogle": [
		"Continue with Google"
	],
	"oauth.continueWithLinkedIn": [
		"Continue with LinkedIn"
	],
	"oauth.continueWithMicrosoft": [
		"Continue with Microsoft"
	],
	"oauth.continueWithSalesforce": [
		"Continue with Salesforce"
	],
	"oauth.continueWithSlack": [
		"Continue with Slack"
	],
	"oauth.continueWithSnapchat": [
		"Continue with Snapchat"
	],
	"oauth.continueWithTikTok": [
		"Continue with TikTok"
	],
	"oauth.continueWithTwitch": [
		"Continue with Twitch"
	],
	"oauth.continueWithX": [
		"Continue with X"
	],
	"oauth.continueWithYahoo": [
		"Continue with Yahoo"
	],
	"otp.success.content": [
		"Your passcode has been successfully verified."
	],
	"passcode.codeSent": [
		"Code sent! Try again in ",
		[
			"timeRemaining"
		],
		"s"
	],
	"passcode.expirationCountdown": [
		"Your code expires in ",
		[
			"timeRemaining"
		],
		"."
	],
	"passcode.expired": [
		"Your code has expired."
	],
	"passcode.resendCode": [
		"Resend code"
	],
	"passcode.sentConfirmation": [
		"A 6-digit passcode was sent to you at <bold>",
		[
			"destination"
		],
		"</bold>."
	],
	"passcode.title": [
		"Enter passcode"
	],
	"passkey.editing.label": [
		"Passkey name"
	],
	"passkey.registrationStart.description": [
		"Passkeys are encrypted digital keys you create using your fingerprint, face, or screen lock. Creating a Passkey will allow you to easily and securely log in to your account."
	],
	"passkey.registrationStart.error.noUser": [
		"Error: Cannot use PasskeyRegistration component without active user authenticated."
	],
	"passkey.registrationStart.subtitle": [
		"With Passkeys you don't need to remember complex passwords."
	],
	"passkey.registrationStart.title": [
		"Set up a new Passkey"
	],
	"passkey.registrationSuccess.deleteWarning": [
		"Once deleted, the passkey cannot be restored."
	],
	"passkey.registrationSuccess.existingPasskeys": [
		"Existing Passkeys"
	],
	"passkey.registrationSuccess.setupAnother": [
		"Set up another Passkey"
	],
	"passkey.registrationSuccess.title": [
		"Passkey successfully created!"
	],
	"passkey.success.content": [
		"Your Passkey has been successfully authenticated."
	],
	"password.breached.content": [
		"A different site where you use the same password had a security issue recently. For your safety, an email was sent to you at <bold>",
		[
			"email"
		],
		"</bold> to reset your password."
	],
	"password.breached.title": [
		"Check your email to set a new password"
	],
	"password.createAccount.content": [
		"Finish creating your account by setting a password."
	],
	"password.createAccount.title": [
		"Create an account"
	],
	"password.forgot.content": [
		"A link to reset your password was sent to you at <bold>",
		[
			"email"
		],
		"</bold>."
	],
	"password.forgot.title": [
		"Forgot your password?"
	],
	"password.login.title": [
		"Log in"
	],
	"password.requirement.fulfilled": [
		"Fulfilled"
	],
	"password.requirement.notFulfilled": [
		"Not fulfilled"
	],
	"password.requirement.suggestion": [
		"Suggestion"
	],
	"password.requirement.warning": [
		"Warning"
	],
	"password.reset.loggingInProgress": [
		"Logging in..."
	],
	"password.reset.loginWithoutPassword": [
		"Login without a password"
	],
	"password.reset.title": [
		"Reset your password"
	],
	"password.resetRequired.content": [
		"We want to make sure your account is secure and that it's really you logging in! A login link was sent to you at <bold>",
		[
			"email"
		],
		"</bold>."
	],
	"password.resetRequired.title": [
		"Check your email to set a new password"
	],
	"password.setNew.content": [
		"A login link was sent to you at <bold>",
		[
			"email"
		],
		"</bold>."
	],
	"password.setNew.title": [
		"Check your email"
	],
	"password.setPassword.title": [
		"Set a password"
	],
	"password.strength": [
		"Password strength: ",
		[
			"score"
		],
		" out of 4."
	],
	"password.strength.accepted": [
		"Password accepted."
	],
	"password.strength.notAccepted": [
		"Password not accepted."
	],
	"password.strength.requirementsNotMet": [
		"Your password must meet all requirements."
	],
	"password.strengthError.breached": [
		"This password may have been used on a different site that experienced a security issue. Please choose another password."
	],
	"password.strengthError.complexity": [
		[
			"complexity",
			"plural",
			{
				one: [
					"Must contain ",
					"#",
					" of the following: uppercase letter, lowercase letter, number, symbol"
				],
				other: [
					"Must contain ",
					"#",
					" of the following: uppercase letter, lowercase letter, number, symbol"
				]
			}
		]
	],
	"password.strengthError.minimumLength": [
		[
			"characterLength",
			"plural",
			{
				one: [
					"Must be at least ",
					"#",
					" character long"
				],
				other: [
					"Must be at least ",
					"#",
					" characters long"
				]
			}
		]
	],
	"password.zxcvbn.suggestion.addWords": [
		"Add another word or two. Uncommon words are better."
	],
	"password.zxcvbn.suggestion.allUppercase": [
		"All-uppercase is almost as easy to guess as all-lowercase."
	],
	"password.zxcvbn.suggestion.avoidDatesAndYearsAssociatedWithYou": [
		"Avoid dates and years that are associated with you."
	],
	"password.zxcvbn.suggestion.avoidRecentYears": [
		"Avoid recent years."
	],
	"password.zxcvbn.suggestion.avoidRepeats": [
		"Avoid repeated words and characters."
	],
	"password.zxcvbn.suggestion.avoidSequences": [
		"Avoid sequences."
	],
	"password.zxcvbn.suggestion.avoidYearsAssociatedWithYou": [
		"Avoid years that are associated with you."
	],
	"password.zxcvbn.suggestion.capitalization": [
		"Capitalization doesn't help very much."
	],
	"password.zxcvbn.suggestion.longerKeyboardPattern": [
		"Use a longer keyboard pattern with more turns."
	],
	"password.zxcvbn.suggestion.noSymbolsDigitsUppercase": [
		"No need for symbols, digits, or uppercase letters."
	],
	"password.zxcvbn.suggestion.predictableSubstitutions": [
		"Predictable substitutions like '@' instead of 'a' don't help very much."
	],
	"password.zxcvbn.suggestion.reversed": [
		"Reversed words aren't much harder to guess."
	],
	"password.zxcvbn.suggestion.useAFewWords": [
		"Use a few words, avoid common phrases."
	],
	"password.zxcvbn.warning.commonNames": [
		"Common names and surnames are easy to guess."
	],
	"password.zxcvbn.warning.dates": [
		"Dates are often easy to guess."
	],
	"password.zxcvbn.warning.longerRepeats": [
		"Repeats like \"abcabcabc\" are only slightly harder to guess than \"abc\"."
	],
	"password.zxcvbn.warning.names": [
		"Names and surnames by themselves are easy to guess."
	],
	"password.zxcvbn.warning.recentYears": [
		"Recent years are easy to guess."
	],
	"password.zxcvbn.warning.repeats": [
		"Repeats like \"aaa\" are easy to guess."
	],
	"password.zxcvbn.warning.sequences": [
		"Sequences like \"abc\" or \"6543\" are easy to guess."
	],
	"password.zxcvbn.warning.shortKeyboardPatterns": [
		"Short keyboard patterns are easy to guess."
	],
	"password.zxcvbn.warning.similarToCommonPassword": [
		"This is similar to a commonly used password."
	],
	"password.zxcvbn.warning.straightRows": [
		"Straight rows of keys are easy to guess."
	],
	"password.zxcvbn.warning.top100CommonPassword": [
		"This is a top-100 common password."
	],
	"password.zxcvbn.warning.top10CommonPassword": [
		"This is a top-10 common password."
	],
	"password.zxcvbn.warning.veryCommonPassword": [
		"This is a very common password."
	],
	"password.zxcvbn.warning.wordByItself": [
		"A word by itself is easy to guess."
	],
	"provider.lastUsed": [
		"Last used"
	],
	"success.title": [
		"Success!"
	],
	"tab.email": [
		"Email"
	],
	"tab.listLabel": [
		"Select login method"
	],
	"tab.text": [
		"Text"
	],
	"tab.whatsapp": [
		"WhatsApp"
	],
	"watermark.altText": [
		"Stytch by Twilio"
	],
	"watermark.poweredBy": [
		"Powered by"
	]
};

export { messages$1 as messages };
//# sourceMappingURL=en.json.mjs.map
